import UserHomeBase from './UserHomeBase';

const StudentHome = () => <UserHomeBase />;

export default StudentHome;
